<template>
  <div class="month-calendar-cont">
    <div class="month-calendar">
      <el-button-group class="calendar-header">
        <el-button class="calendar-header-action prev" @click="prevMonth" icon="el-icon-arrow-left"></el-button>
        <el-button class="calendar-header-date">{{ displayMonthYear }}</el-button>
        <el-button class="calendar-header-action next" @click="nextMonth" icon="el-icon-arrow-right"></el-button>
      </el-button-group>
      <div class="weekdays">
        <div class="weekday" v-for="day in weekDays" :key="day">{{ day }}</div>
      </div>
      <el-skeleton :loading=isLoadingDays animated class="calendar-grid-cont">
        <template slot="template">
          <div class="calendar-grid">
            <el-skeleton-item class="day-loading" v-for="day in daysInMonth" :key="day.date.format('DD-MM-YYYY')" />
          </div>
        </template>
        <template>
          <div class="calendar-grid" style="display: grid; grid-template-columns: repeat(7, 1fr); gap: 8px;">
            <el-button @click="miniCalDateChoosed(day.date)" class="day" :disabled="isDisabled(day.date)"
              v-for="day in daysInMonth" :key="day.date.format('DD-MM-YYYY')"
              :class="{ 'disabled': isDisabled(day.date), 'notInMonth': !day.isCurrentMonth, }">
              <div class="calendar-grid-day">
                {{ day.date.date() }}
              </div>
              <div v-if="isDiscount(day.date)" class="discount-badge">
                <p>
                  -{{ isDiscount(day.date) }}%
                </p>
              </div>
            </el-button>
          </div>
        </template>
      </el-skeleton>
    </div>
    <div v-if="getEventInfos" class="bookingMessage">
      <i class="el-icon-info"></i>
      <span class="bookingMessage-name">{{ getEventInfos.title }}</span><br />
      <span class="bookingMessage-text">{{ getEventInfos.desc }}</span>
    </div>
    <div v-if="getAllInfos.restoBookingMessage && getAllInfos.restoBookingMessage !== ''" class="bookingMessage">
      <i class="el-icon-info"></i>
      <span class="bookingMessage-text" v-html="renderMarkdown(getAllInfos.restoBookingMessage)"></span>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import { mapActions, mapGetters } from 'vuex';
import router from '../../router';
import { renderMarkdown } from '../../tools/markdownHelper';

dayjs.locale('fr')



export default {
  name: 'MonthCalendar',
  data() {
    return {
      currentDate: dayjs(),
      weekDays: ['Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.', 'Dim.']
    }
  },
  mounted() {
    if (this.getInitialized) {
      return
    }
    this.setInitialized(true)
    const id = router.currentRoute.params.id
    this.loadPublicInfos(id)
    if (router.currentRoute.name === "google-external") {
      const start = new URLSearchParams(window.location.search).get('start') || undefined;
      const nbPersons = new URLSearchParams(window.location.search).get('party_size') || undefined;

      if (start && nbPersons) {
        this.loadPreselectedSteps({
          start: start,
          nbPersons: nbPersons
        })
        return
      }
    }
    this.loadAvailableDays()
  },
  computed: {
    ...mapGetters({
      getAllInfos: 'infos/getAllInfos',
      getCurrentDateLinear: 'calendar/getCurrentDateLinear',
      isLoadingDays: 'forkBooking/isLoadingDays',
      getAvailableDays: 'forkBooking/getAvailableDays',
      getEventInfos: 'forkBooking/getEventInfos',
      getInitialized: 'forkBooking/getInitialized'
    }),
    isPrevMonthDisabled() {
      let nowFormatted = dayjs().format('YYYY-MM')
      let currentFormatted = this.currentDate.format('YYYY-MM')
      return currentFormatted <= nowFormatted
    },
    displayMonthYear() {
      return this.currentDate.format('MMMM YYYY')
    },
    daysInMonth() {
      const startOfMonth = this.currentDate.startOf('month')

      let startDay = startOfMonth.day() === 0 ? startOfMonth.subtract(6, 'day') : startOfMonth.subtract(startOfMonth.day() - 1, 'day')

      let days = []
      for (let i = 0; i < 42; i++) {
        const day = dayjs(startDay).add(i, 'day')
        days.push({
          date: day,
          isCurrentMonth: day.isSame(this.currentDate, 'month')
        })
      }

      return days
    }
  },
  methods: {
    renderMarkdown,
    isDisabled(day) {
      if (this.isLoadingDays || this.getAvailableDays === null) return true
      const availableDates = this.getAvailableDays.map(date => new Date(date.date).toDateString())
      return !availableDates.includes(new Date(day.toDate()).toDateString())
    },
    isDiscount(day) {
      if (this.isLoadingDays || this.getAvailableDays === null) return false
      const availableDates = this.getAvailableDays.find(date => new Date(date.date).toDateString() === new Date(day.toDate()).toDateString())
      if (availableDates) {
        return availableDates.discount
      }
    },
    nextMonth() {
      this.currentDate = this.currentDate.add(1, 'month')
    },
    prevMonth() {
      this.currentDate = this.currentDate.subtract(1, 'month')
    },
    ...mapActions({
      setSelectedDayTo: 'forkBooking/setSelectedDayTo',
      setCurrentStep: 'forkBooking/setCurrentStep',
      setInitialized: 'forkBooking/setInitialized',
      loadPublicInfos: 'infos/loadPublicInfos',
      loadAvailableDays: 'forkBooking/loadAvailableDays',
      loadPreselectedSteps: 'forkBooking/loadPreselectedSteps'
    }),
    miniCalDateChoosed: function (e) {
      const date = e.toDate()
      this.setSelectedDayTo({ day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() })
      this.setCurrentStep(1)
    }
  }
}
</script>

<style scoped lang="scss">
.month-calendar-cont {
  height: calc(100% - 73px);
  overflow: auto;
}

.calendar-header-date {
  width: calc((100% - 30px) / 7 * 5 + 32px);
  height: 40px;
}

.calendar-header-action {
  padding: 0px;
  height: 40px;
  width: calc((100% - 30px) / 7);

  &.prev {
    border-radius: 50px 0px 0px 50px;
  }

  &.next {
    border-radius: 0px 50px 50px 0px;
  }
}

.month-calendar {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
}

.calendar-header {
  width: 100%;
  justify-content: space-between;
  margin-bottom: 10px;
}

.weekdays {
  display: flex;
  gap: 8px;
  width: 100%;
  margin-bottom: 8px;
}

.weekday {
  text-align: center;
  width: calc((100% - 30px) / 7);
  text-transform: uppercase;
  font-size: 12px;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  width: 100%;

  .day {
    overflow: hidden;

    .calendar-grid-day {
      height: 55%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .discount-badge {
      height: 45%;
      background-color: var(--color-primary);
      display: flex;
      justify-content: center;
      align-items: center;

      p {
        color: var(--color-primary-contrast);
        font-size: 11px;
        font-weight: 700;
        margin: 0;
      }
    }
  }
}

.calendar-grid-cont {
  width: 100%;
}

.day {
  aspect-ratio: 1;
  padding: 0px;
  margin: 0px;
  background-color: #fff;
  text-align: center;
  border-radius: 50%;
}

.day-loading {
  aspect-ratio: 1;
  height: unset;
  border-radius: 50%;
}

.disabled {
  background-color: rgb(236, 237, 239);
  color: rgb(149, 155, 167);

  .discount-badge {
    display: none !important;
  }
}

.notInMonth {
  opacity: 0.6;
}

.bookingMessage {
  white-space: pre-line;
  gap: 4px;
  margin: 0 16px 16px 16px;
  padding: 8px;
  border-radius: 20px;

  &-text {
    font-size: 14px;
  }

  &-name {
    font-size: 16px;
    font-weight: 700;
  }
}
</style>